import { ROLES } from "config/constants";
import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Hook to check user permissions for modules
 * @param {Array} permissions - Array of user permissions from API
 * @returns {Function} hasPermission(moduleName: string, action?: string)
 */
export function useUserPermissions() {
  const user = useSelector(state => state.auth.user);
  const permissions = useSelector(state => state.auth.permissions);
  
  // Build a map for quick lookups
  const permissionMap = useMemo(() => {
    const map = {};
    permissions?.length && permissions.forEach((perm) => {
      const moduleName = perm.userPermissionModule?.module_name;
      if (moduleName) {
        map[moduleName] = new Set(perm.module_permissions || []);
      }
    });
    return map;
  }, [permissions]);

  /**
   * Check if user has permission
   * @param {string} moduleName - Module name, e.g. "client_school"
   * @param {string} [action] - Optional action: "view", "create", etc.
   * @returns {boolean}
   */
  function hasPermission(moduleName, action) {
    // admin has all permissions
    if(user?.role?.id === ROLES.admin) {
      return true;
    }

    if (!permissionMap[moduleName]) return false;
    if (!action) return true; // module exists, no action specified
    return permissionMap[moduleName].has(action);
  }

  return { hasPermission };
}
